import type { DatePickerValue } from '@latitude/datepicker';
import type { SelectedFilterValues } from '@latitude/filter-toolbar';

export const extractDateRange = (
  filterState: SelectedFilterValues,
  filterId: string,
): DatePickerValue<'range'> | undefined => {
  const value = filterState[filterId];
  if (!value || typeof value !== 'object') {
    return undefined;
  }
  return value as DatePickerValue<'range'>;
};
